import { render, staticRenderFns } from "./DocumentPlusIcon.vue?vue&type=template&id=0bdc8ee2"
import script from "./DocumentPlusIcon.vue?vue&type=script&lang=ts"
export * from "./DocumentPlusIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports